import React, { useEffect, useState } from "react";
import { Col, Form, Row, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import profilepageman from "../../assets/images/dummy-profile-pic.jpg";
import infoIcon from "../../assets/images/infobtnblue.svg";
import profilepagebg from "../../assets/images/profilepagebg.png";
import { commonservices } from "../../services/CommonServices";
import {
  GetByPrimarykey,
  UserProfileUpdate,
} from "../../services/ReduxTookit/Slice/UserRedux";
import { userInfo } from "../../services/ReduxTookit/UserInfoSlice";
import SubmitLoading from "../../component/common-component/Loaders/SubmitLoading";
import Skeleton from "react-loading-skeleton";
import Loader, { LoaderType } from "../../component/common-component/Loader";
import PhoneInput, {
  formatPhoneNumber,
  formatPhoneNumberIntl,
  isValidPhoneNumber,
  isPossiblePhoneNumber,
} from "react-phone-number-input";

const ProfileManagementModel = () => {
  let ProfileInfo = useSelector((state) => state?.userinfo?.UserInfo);

  const [ProfileDetailLoading, setProfileDetailLoading] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [ProfilePicLoader, setProfilePicLoader] = useState(false);
  const [EditState, setEditStete] = useState({
    firstname: false,
    lastname: false,
    phone: false,
  });

  const checkUserIsReviewer = () => {
    let isReviewer = false;
    if (ProfileInfo?.associationtype === "Reviewers") {
      isReviewer = true;
    }
    return isReviewer;
  };
  let dispatch = useDispatch();
  // const [file, setFile] = useState();
  const [input, setInput] = useState({
    firstname: "",
    lastname: "",
    phonenumber: "",
    profilepicfile: "",
    email: "",
    errors: {
      firstname: "",
      lastname: "",
      phonenumber: "",
      profilepicfile: "",
      ValidationRules: [
        {
          FieldName: "firstname",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "lastname",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "email",
          ValidationType: "email",
          ValidationMessage: "Invalid email format",
        },
        {
          FieldName: "email",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "phonenumber",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
      ],
    },
  });
  

  // const HandleProfileChange = async (e) => {
  //   let file2 = e.target.files[0];
  //
  //   if (!file2) return;
  //   if (file2?.size > 5000000) {
  //     file2 = null;
  //     return toast.error("File size must not exceed 5 MB.");
  //   }
  //   if (file2.type !== "image/png" && file2.type !== "image/jpeg") {
  //     return toast.error("Only PNG and JPEG images are allowed.");
  //   }
  //   setInput({
  //     ...input,
  //     profilepicfile: file2,
  //   });
  //   setFile(URL.createObjectURL(file2));
  //   handleSubmit(e, file2);
  // };
  const HandleProfileChange = async (e) => {
    let file2 = e.target.files[0];

    // Check if a file is selected
    if (!file2) return;

    // Check file size (5 MB limit)
    if (file2.size > 5 * 1024 * 1024) {
      toast.error("File size must not exceed 5 MB.");
      e.target.value = null; // Reset the file input
      return;
    }

    // Check file type (only PNG and JPEG allowed)
    if (file2.type !== "image/png" && file2.type !== "image/jpeg") {
      toast.error("Only PNG and JPEG images are allowed.");
      e.target.value = null; // Reset the file input
      return;
    }

    // Update state with the valid file
    setInput({
      ...input,
      profilepicfile: file2,
    });

    // Create a URL for the file preview
    // setFile(URL.createObjectURL(file2));

    // Handle form submission or further processing
    handleSubmit(e, file2);
  };
  async function getProfileDetail() {
    setProfileDetailLoading(true);
    setProfilePicLoader(true);
    dispatch(GetByPrimarykey({}))?.then((response) => {
      setProfilePicLoader(false);
      if (response?.payload?.isValidate) {
        if (response?.payload?.data?.data) {
          // setFile(response?.payload?.data?.data?.profilepicurl);
          setInput({
            ...input,
            firstname: response?.payload?.data?.data?.firstname,
            lastname: response?.payload?.data?.data?.lastname,
            profilepicfile: response?.payload?.data?.data?.profilepicurl
              ? response?.payload?.data?.data?.profilepicurl
              : profilepageman,
            phonenumber:
              response?.payload?.data?.data?.associationtype === "Reviewers"
                ? "0000000000"
                : response?.payload?.data?.data?.phonenumber,
            email: response?.payload?.data?.data?.email,
          });
          setProfileDetailLoading(false);
        }
      }
      if (!response?.payload?.isValidate) {
        setProfileDetailLoading(false);
      }
    });
  }
  useEffect(() => {
    getProfileDetail();
  }, []);

  const handleSubmit = async (e, payloadFile) => {
    e.preventDefault();
    if (payloadFile) {
      setProfilePicLoader(true);
    }

    let obj = commonservices.fnCheckValidationOfObject(input);

    setInput({
      ...obj.obj,
    });

    if (obj.isValid) {
      setLoading(true);
      let body = {
        profilepicfile: payloadFile ? payloadFile : input?.profilepicfile,
        firstname: input?.firstname,
        lastname: input?.lastname,
        phonenumber: input?.phonenumber,
      };
      dispatch(UserProfileUpdate(body))?.then((response) => {
        setLoading(false);
        if (payloadFile) {
          setProfilePicLoader(false);
        }
        if (response?.payload?.isValidate) {
          dispatch(GetByPrimarykey({}))?.then((response) => {
            if (response?.payload?.isValidate) {
              if (response?.payload?.data?.data) {
                // setFile(response?.payload?.data?.data?.profilepicurl);
                let temp = {
                  ...ProfileInfo,
                  displayname: response?.payload?.data?.data?.displayname,
                  profilepic: response?.payload?.data?.data?.profilepicurl,
                };
                dispatch(userInfo(temp));
                setInput({
                  ...input,
                  firstname: response?.payload?.data?.data?.firstname,
                  lastname: response?.payload?.data?.data?.lastname,
                  profilepicfile: response?.payload?.data?.data?.profilepicurl
                    ? response?.payload?.data?.data?.profilepicurl
                    : profilepageman,
                  phonenumber:
                    response?.payload?.data?.data?.associationtype ===
                    "Reviewers"
                      ? "0000000000"
                      : response?.payload?.data?.data?.phonenumber,
                  email: response?.payload?.data?.data?.email,
                });
                setProfileDetailLoading(false);
              }
            }
            // if (response?.payload?.data?.data) {
            //   let temp = {
            //     ...ProfileInfo,
            //     displayname: response?.payload?.data?.data?.displayname,
            //     profilepic: response?.payload?.data?.data?.profilepicurl,
            //   };
            //   dispatch(userInfo(temp));
            // }
          });
        }

        if (!response?.payload?.isValidate) {
        }
      });
    }
  };

  return (
    <>
      <div className="main-profile-bg">
        <div className="profile-main-inner">
          <div className="profile-banner">
            <img className="w-100" src={profilepagebg} alt="profilepagebg" />
          </div>
          <div className="profilepage-icon">
            {ProfilePicLoader ? (
              <Skeleton height={120} width={120} circle />
            ) : (
              <img
                className="edit-profile-pic"
                src={
                  input?.profilepicfile ? input?.profilepicfile : profilepageman
                }
                alt="profile"
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null;
                  currentTarget.src = profilepageman;
                }}
              />
            )}
            <input
              type="file"
              className="form-control choseprofile"
              id="profileImg11"
              accept="image/png, image/jpeg"
              onChange={HandleProfileChange}
            />
          </div>
          <Form
            onSubmit={(e) => {
              handleSubmit(e);
            }}
          >
            {ProfileDetailLoading ? (
              <Loader type={LoaderType.Line} count={4} />
            ) : (
              <div className="user-data-show">
                <Row className="user-profile">
                  <Col xl={4}>
                    <p>First Name</p>
                  </Col>
                  <Col xl={4}>
                    {EditState.firstname ? (
                      <div className="position-relative">
                        <Form.Control
                          type="text"
                          maxLength={67}
                          placeholder="First Name"
                          className="common-input"
                          value={input.firstname}
                          onChange={(e) =>
                            setInput({
                              ...input,
                              firstname: e.target.value,
                            })
                          }
                          isInvalid={input?.errors?.firstname}
                        />
                        {input.errors.firstname && (
                          <Form.Control.Feedback type="invalid">
                            <span className="error-message-icon">
                              <img
                                src={infoIcon}
                                alt="infoIcon"
                                title={input.errors.firstname}
                              />
                            </span>
                          </Form.Control.Feedback>
                        )}
                      </div>
                    ) : (
                      <p>
                        <b>{input?.firstname}</b>
                      </p>
                    )}
                  </Col>
                  <Col xl={4} className="text-end">
                    <div className="edit-user">
                      {EditState.firstname ? (
                        <div className="machin-detail-footer-btns m-0">
                          {/* <Button className="blue-btn" type="submit">
                          {Loading ? (
                            <>
                              <span>Loading</span>{" "}
                              <Spinner
                                className="ms-1"
                                animation="border"
                                role="status"
                                size="sm"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </Spinner>
                            </>
                          ) : (
                            "Submit"
                          )}
                        </Button> */}
                          {Loading ? (
                            <>
                              <Spinner
                                className="ms-1"
                                animation="border"
                                role="status"
                                size="sm"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </Spinner>
                            </>
                          ) : (
                            // <SubmitLoading
                            <Link
                              onClick={(e) => handleSubmit(e)}
                              className="red-color-text text-decoration-none"
                            >
                              Update
                            </Link>
                          )}
                        </div>
                      ) : (
                        <>
                          {ProfileInfo?.isorganization &&
                            ProfileInfo?.Subscribers && (
                              <Link
                                onClick={(e) => {
                                  setEditStete({
                                    ...EditState,
                                    firstname: !EditState.firstname,
                                    phone: false,
                                    lastname: false,
                                  });
                                }}
                              >
                                Edit
                              </Link>
                            )}
                        </>
                      )}
                    </div>
                  </Col>
                </Row>
                <Row className="user-profile">
                  <Col xl={4}>
                    <p>Last Name</p>
                  </Col>
                  <Col xl={4}>
                    {EditState.lastname ? (
                      <div className="position-relative">
                        <Form.Control
                          type="text"
                          maxLength={67}
                          placeholder="Last Name"
                          className="common-input"
                          value={input.lastname}
                          onChange={(e) =>
                            setInput({
                              ...input,
                              lastname: e.target.value,
                            })
                          }
                          isInvalid={input?.errors?.lastname}
                        />
                        {input.errors.lastname && (
                          <Form.Control.Feedback type="invalid">
                            <span className="error-message-icon">
                              <img
                                src={infoIcon}
                                alt="infoIcon"
                                title={input.errors.lastname}
                              />
                            </span>
                          </Form.Control.Feedback>
                        )}
                      </div>
                    ) : (
                      <p>
                        <b>{input?.lastname}</b>
                      </p>
                    )}
                  </Col>
                  <Col xl={4} className="text-end">
                    <div className="edit-user">
                      {EditState.lastname ? (
                        <>
                          {Loading ? (
                            <>
                              <Spinner
                                className="ms-1"
                                animation="border"
                                role="status"
                                size="sm"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </Spinner>
                            </>
                          ) : (
                            // <SubmitLoading />
                            <Link
                              onClick={(e) => handleSubmit(e)}
                              className="red-color-text text-decoration-none"
                            >
                              Update
                            </Link>
                          )}
                        </>
                      ) : (
                        <>
                          {ProfileInfo?.isorganization &&
                            ProfileInfo?.Subscribers && (
                              <Link
                                onClick={(e) => {
                                  setEditStete({
                                    ...EditState,
                                    lastname: !EditState.lastname,
                                    phone: false,
                                    firstname: false,
                                  });
                                }}
                              >
                                Edit
                              </Link>
                            )}
                        </>
                      )}
                    </div>
                  </Col>
                </Row>
                <Row className="user-profile">
                  <Col xl={4}>
                    <p>Email</p>
                  </Col>
                  <Col xl={8}>
                    <p>
                      <b>{input?.email}</b>
                    </p>
                  </Col>
                </Row>
                {!checkUserIsReviewer() && (
                  <Row className="user-profile">
                    <Col xl={4} mb-1>
                      <p>Phone</p>
                    </Col>
                    <Col xl={4}>
                      {EditState.phone ? (
                        <div className="position-relative">
                          {/* <Form.Control
                            type="text"
                            maxLength={17}
                            placeholder="Phone"
                            className="common-input"
                            value={input.phonenumber}
                            onChange={(e) =>
                              setInput({
                                ...input,
                                phonenumber: e.target.value,
                              })
                            }
                            isInvalid={input?.errors?.phonenumber}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                          /> */}

                          <PhoneInput
                            id="mobileNum"
                            international
                            defaultCountry="US"
                            placeholder="Enter phone number"
                            value={input.phonenumber}
                            maxLength={18}
                            onChange={(value) =>
                              setInput({
                                ...input,
                                phonenumber: value,
                              })
                            }
                            inputProps={{
                              name: "phone",
                              required: true,
                            }}
                            className={
                              input.errors.phonenumber
                                ? "country-selection error-border"
                                : "country-selection"
                            }
                            title={input.errors.phonenumber}
                          />
                          {input.errors.phonenumber && (
                            <Form.Control.Feedback type="invalid">
                              <span className="error-message-icon">
                                <img
                                  src={infoIcon}
                                  alt="infoIcon"
                                  title={input.errors.phonenumber}
                                />
                              </span>
                            </Form.Control.Feedback>
                          )}
                        </div>
                      ) : (
                        <p>
                          <b>{input?.phonenumber}</b>
                        </p>
                      )}
                    </Col>
                    <Col xl={4} className="text-end">
                      <div className="edit-user d-flex align-items-center justify-content-end h-100">
                        {EditState.phone ? (
                          <>
                            {Loading ? (
                              <>
                                <Spinner
                                  className="ms-1"
                                  animation="border"
                                  role="status"
                                  size="sm"
                                >
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </Spinner>
                              </>
                            ) : (
                              // <SubmitLoading />
                              <Link
                                onClick={(e) => handleSubmit(e)}
                                className="red-color-text"
                              >
                                Update
                              </Link>
                            )}
                          </>
                        ) : (
                          <Link
                            onClick={(e) => {
                              setEditStete({
                                ...EditState,
                                phone: !EditState.phone,
                                firstname: false,
                                lastname: false,
                              });
                            }}
                          >
                            Edit
                          </Link>
                        )}
                      </div>
                    </Col>
                  </Row>
                )}
              </div>
            )}
          </Form>
        </div>
      </div>
    </>
  );
};

export default ProfileManagementModel;
